import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=37c0868d"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=37c0868d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports